import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api, errMsg } from '../../lib/api';
import { toast } from 'sonner';
import { CheckSquare, Check } from '@phosphor-icons/react';

export const TasksPanel = () => {
  const qc = useQueryClient();
  const { data: tasks } = useQuery({ queryKey: ['adm-tasks'], queryFn: () => api.get('/admissions/tasks').then((r) => r.data) });
  const doneMut = useMutation({
    mutationFn: (id) => api.patch(`/admissions/tasks/${id}`),
    onSuccess: () => { toast.success('Task completed'); qc.invalidateQueries({ queryKey: ['adm-tasks'] }); qc.invalidateQueries({ queryKey: ['adm-analytics'] }); },
    onError: (e) => toast.error(errMsg(e)),
  });
  return (
    <div className="bg-white border border-slate-200 rounded-md p-4" data-testid="tasks-panel">
      <p className="font-mono-label text-[10px] uppercase text-slate-400 mb-2 flex items-center gap-1.5"><CheckSquare size={14} className="text-orange-600" />Follow-up tasks</p>
      {(tasks || []).map((t) => (
        <div key={t.id} className="flex items-center gap-2 py-1.5 border-t border-slate-50 text-sm" data-testid={`task-row-${t.id}`}>
          <div className="flex-1 min-w-0">
            <p className="truncate">{t.title} <span className="text-slate-400">· {t.applicant_name}</span></p>
            {t.due_date && <p className={`text-[10px] font-mono-label uppercase ${t.overdue ? 'text-rose-600' : 'text-slate-400'}`}>{t.overdue ? 'overdue ' : 'due '}{t.due_date}</p>}
          </div>
          <button data-testid={`task-done-${t.id}`} onClick={() => doneMut.mutate(t.id)} title="Mark done"
            className="shrink-0 text-xs border border-slate-200 rounded px-2 py-1 hover:border-green-600 hover:text-green-700 flex items-center gap-1"><Check size={12} />Done</button>
        </div>
      ))}
      {(tasks || []).length === 0 && <p className="text-sm text-slate-400 py-2">No open follow-ups. Add one from any application card.</p>}
    </div>
  );
};
